module.exports = __webpack_public_path__ + "img/DSC_0088.f6ad8c0b.jpg";